import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import calendario from "../../Assets/images/brands/calendar.png";
import facturas from "../../Assets/images/brands/facturas.png";
import pacientes from "../../Assets/images/brands/pacientes.png";
import logoFallback from "../../Assets/images/logo-A1.png";
import avatarDefault from "../../Assets/images/users/default-avatar.jpg";
import useAuth from "../../hook/useAuth";
import { GetTokenDecoded } from "../../utils/storeUsuario";
import ThemeSelector from "./ThemeSelector";
import { tituloDeRuta } from "../../utils/tituloPagina";
import { usePageHeader } from "../../context/PageHeaderContext";
import "../../styles/TopBar.css";

export default function AdminNavbar({ collaseSidebar, toggleMenu }) {
    const { logout } = useAuth();
    // REDISENO-SMARTMEDIC FASE 2: la barra superior deja de estar vacía --
    // dice dónde estás y, si la pantalla lo publica, cuántos registros hay
    // bajo el filtro activo.
    const { pathname } = useLocation();
    const { subtitulo } = usePageHeader();
    const titulo = tituloDeRuta(pathname);
    const [logoClinica, setLogoClinica] = useState(logoFallback);

    useEffect(() => {
        const storedLogo = localStorage.getItem("logoClinica");
        if (storedLogo) {
            setLogoClinica(storedLogo);
        }
    }, []);

    return (
        <header id="page-topbar">
            <div className="navbar-header">
                <div className="d-flex">
                    <div className="navbar-brand-box">
                        <a href="#;" className="logo logo-dark">
                            <span className="logo-sm">
                                <img src={logoClinica} alt="Logo Clínica" width={24} />
                            </span>
                            <span className="logo-lg">
                                <img src={logoClinica} alt="Logo Clínica" width={150} />
                            </span>
                        </a>
                        <a href="#;" className="logo logo-light">
                            <span className="logo-sm">
                                <img src={logoClinica} alt="Logo Clínica" width={24} />
                            </span>
                            <span className="logo-lg">
                                <img src={logoClinica} alt="Logo Clínica" width={24} />
                                {!collaseSidebar && <span className="logo-txt">SmartMedic</span>}
                            </span>
                        </a>
                    </div>

                    <button
                        type="button"
                        className="btn btn-sm px-3 font-size-16 header-item"
                        onClick={toggleMenu}
                    >
                        <i className="fa fa-fw fa-bars"></i>
                    </button>

                    {titulo && (
                        <div className="tb-titulo" data-testid="topbar-titulo">
                            <span className="tb-titulo__principal">{titulo}</span>
                            {subtitulo && (
                                <span className="tb-titulo__sub" data-testid="topbar-subtitulo">
                                    {subtitulo}
                                </span>
                            )}
                        </div>
                    )}
                </div>

                <div className="d-flex">
                    <div className="dropdown d-inline-block">
                        <button
                            type="button"
                            className="btn header-item bg-soft-light"
                            id="page-header-user-dropdown"
                            data-bs-toggle="dropdown"
                        >
                            <img className="rounded-circle header-profile-user" src={avatarDefault} alt="Avatar" />
                            <span className="d-none d-xl-inline-block ms-1 fw-medium">
                                {GetTokenDecoded().full_name}
                            </span>
                            <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                        </button>
                        <div className="dropdown-menu dropdown-menu-end">
                            <a className="dropdown-item" href="#;"><i className="mdi mdi-face-profile me-1"></i> Perfil</a>
                            <a className="dropdown-item" href="#;"><i className="mdi mdi-lock me-1"></i> Cambiar Clave</a>
                            <a className="dropdown-item" href="#;"><i className="mdi mdi-switch me-1"></i> Cambiar Clínica</a>
                            <div className="dropdown-divider"></div>
                            <ThemeSelector />
                            <div className="dropdown-divider"></div>
                            <a className="dropdown-item" href="#;" onClick={logout}>
                                <i className="mdi mdi-logout me-1"></i> Cerrar sesión
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}
